// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"af01873d","iconContainer":"b3135996"};